import React, { useContext } from 'react';
import { useLocalizedStrings } from '../../Localization';
import { PublicConfigurationContext } from '../../Context';
import { useHistory } from 'react-router-dom';
import { Button, CompactSidebarNavTrigger, Heading,  Icon,  NumberDisplay, Page } from '@aidkitorg/component-library';
import { AdminPanelNav } from '../AdminPanelApp';
import { usePayments } from '../../Contexts/PaymentsContext';
import { PaymentsDataTable } from './components/PaymentsDataTable';
import { generateTimestampString } from '../../utils/adminPanel.utils';

export const PaymentsPage = () => {
  const L = useLocalizedStrings()
  const publicConfig = useContext(PublicConfigurationContext);
  const history = useHistory()

  const {
    fetchPaymentsOverview, 
    enabledPayments, 
    paymentsDataTimestamp,

    isPaymentsLoading
  } = usePayments();

  // TODO: uncomment this out before releasing
  // if (publicConfig && publicConfig.adminPanel === false){
  //   history.push("/");
  // }

  const enabledPaymentsCard = <NumberDisplay
    loading={isPaymentsLoading}
    className="max-w-56"
    title={L.admin_panel.payments.enabled_payments}
    value={enabledPayments} 
    unit={L.admin_panel.payments.payments}
    unitSingular={L.admin_panel.payments.payment}
    iconName="PlayCircleIcon" 
    iconColor="blue"
  />

  // TODO: consolidate header footer into a AdminPanelShell Page or something

  const lastUpdated = (
    <div className="flex gap-2 items-center text-gray-700">
      {paymentsDataTimestamp && (
        <div className="flex gap-1 items-center">
          <div>
            <Icon role="decorative" name="ClockIcon"/>
          </div>
          <div>
            {L.admin_panel.payments.last_updated}: {generateTimestampString(paymentsDataTimestamp)}
          </div>
        </div>
      )}
      <div>
        <Button 
          icon={<Icon role="decorative" name="ArrowPathIcon" />} 
          variant="unstyled" size="sm" 
          aria-label="Refresh data"
          onClick={async () => {
            await fetchPaymentsOverview(true)
          }}
        />
      </div>
    </div>
  )
  
  const header = (
    <div className="w-full">
      <div>
        <CompactSidebarNavTrigger />
      </div>
      <div className="flex justify-between items-center">
        <div>
          <Heading level="h1" className="m-0">{L.admin_panel.nav.payments}</Heading>
          <div className="text-lg text-gray-700">{L.admin_panel.payments.payments_about}</div>
        </div>
        <div>
          {lastUpdated}
        </div>
      </div>
    </div>
  )
  
  const footer = (
    <div className="w-full flex justify-between">
      <div>
        <Button variant="link" href="/privacy.html" openInNewWindow>
          {L.privacy_policy}
        </Button>
      </div>
      <div>
        <Button variant="link" href="/tos.html" openInNewWindow>
          {L.terms_and_conditions}
        </Button>
      </div>
    </div>
  )
  
  return (
    <Page 
      className="bg-gray-50"
      header={header}
      sidebar={
        <AdminPanelNav />
      }
      footer={footer}
    >
      <div className="flex flex-col gap-4">
        <div>
          {enabledPaymentsCard}
        </div>
        <div>
          <div className="border rounded-md p-4 bg-white">
            <PaymentsDataTable />
          </div>
        </div>
      </div>
    </Page>
  )
}